import { FirebaseError } from "firebase/app";
import React, { useContext, useEffect, useState } from "react";
import { House, Owner, THouses } from "./ostertalertypes";
import { fetchHouses, fetchOwner } from "./utils/database";

interface IHouseContextProps {
  houses: Map<string, House>;
  owner: Owner;
}

const defaultContextState = {
  houses: new Map(),
  owner: {email: "", phone: "", name: "", impressum: ""},
};

const HouseContext = React.createContext<IHouseContextProps>(defaultContextState);
// Define our own custom convinent hook
export const useHouseContext = () => useContext(HouseContext);

export const HouseProvider: React.FC = (props) => {
  const [houses, setHouses] = useState<THouses>(new Map());
  const [owner, setOwner] = useState<Owner>({email: "", phone: "", name: "", impressum: ""});

  async function getData() {
    try {
      const houses = await fetchHouses();
      setHouses(houses);
      const owner = await fetchOwner();
      setOwner(owner);
    } catch (error) {
      if (error instanceof FirebaseError) {
        console.error("Failed fetching houses: " + error.message);
      } else {
        console.error("Failed fetching houses: " + JSON.stringify(error));
      }
    }
  }

  useEffect(() => {
    getData()
  }, []);

  const contextValue = {
    houses: houses,
    owner: owner
  };
  return <HouseContext.Provider value={contextValue}>{props.children}</HouseContext.Provider>;
};
